const studentPages = {
  index: {
    route: '/',
    v1: false,
  },
  dashboard: {
    route: '/portal/courses',
    v1: false,
  },
  courses: {
    route: '/portal/courses',
    v1: false,
  },
  foundationsOfFocus: {
    route: '/portal/courses/foundations-of-focus',
    v1: false,
  },
  mentalHealthEssentials: {
    route: '/portal/courses/mental-health-essentials',
    v1: false,
  },
  lessons: {
    route: '/portal/lessons',
    v1: false,
  },
  dailyBeats: {
    route: '/portal/beats',
    v1: false,
  },
  focus: {
    route: '/portal/focus',
    v1: false,
  },
  focusPreview: {
    route: '/portal/focus/preview',
    v1: false,
  },
  focusSeshPresets: {
    route: '/portal/focus/presets',
    v1: false,
  },
  focusSeshAddNewPreset: {
    route: '/portal/focus/add-new-preset',
    v1: false,
  },
  focusSeshPlayer: {
    route: '/portal/focus/player',
    v1: false,
  },
  videoLibrary: {
    route: '/portal/video-library',
    v1: false,
  },
  videoLibraryDrilldown: {
    getRoute: (lessonSummaryId: string) => `/portal/video-library/${lessonSummaryId}`,
    v1: false,
  },
  videoHighlight: {
    getRoute: (lessonId: string, videoHighlightId: number) => `/portal/video-library/${lessonId}/${videoHighlightId}`,
    v1: false,
  },
  settings: {
    route: '/portal/settings',
    v1: false,
  },
  joinAnotherClass: {
    getRoute: () => '/portal/settings/join-another-class',
    v1: false,
  },
  focusCoachSettings: {
    getRoute: () => '/portal/settings/focus-coach',
    v1: false,
  },
  focusCoachVoice: {
    getRoute: () => '/portal/settings/focus-coach/voice',
    v1: false,
  },
  autoCheckIns: {
    getRoute: () => '/portal/settings/focus-coach/auto-check-ins',
    v1: false,
  },
  accountSettings: {
    getRoute: () => '/portal/settings/account',
    v1: false,
  },
  updateName: {
    getRoute: () => '/portal/settings/account/update-name',
    v1: false,
  },
  updatePassword: {
    getRoute: () => '/portal/settings/account/update-password',
    v1: false,
  },
  deleteAccount: {
    getRoute: () => '/portal/settings/account/delete-account',
    v1: false,
  },
  deleteAccountConfirm: {
    getRoute: () => '/portal/settings/account/delete-account-confirm',
    v1: false,
  },
  resetStudentViewConfirm: {
    getRoute: () => '/portal/settings/reset-student-view-confirm',
    v1: false,
  },
  lessonPlayer: {
    getRoute: (lessonId: string) => `/portal/lesson/${lessonId}`,
    v1: false,
  },
  dailyBeatPlayer: {
    getRoute: (dailyBeatId: string) => `/portal/daily/${dailyBeatId}`,
    v1: false,
  },
}

export const defaultStudentPage = studentPages.focus

export default studentPages

// We used to use this function for navigation when we needed to
// navigate between the V1 and V2 servers. Now it is just a proxy
// for router.push()
import { NextRouter } from 'next/router'

export const navigationPush = (url: string, router: NextRouter, v1: boolean = false, params: Record<string, string> = {}, shallow: boolean = false): void => {
  const paramsString = Object.keys(params).reduce((string, key) => {
    return !string ? `${key}=${params[key]}` : `${string}&${key}=${params[key]}`
  }, '')
  if (v1) {
    window.location.href = `${url}${!!paramsString ? `?${paramsString}` : ''}`
  } else {
    router.push(`${url}${!!paramsString ? `?${paramsString}` : ''}`, undefined, { shallow: shallow })
  }
}

export const shallowQueryParamUpdate = (router: NextRouter, params: Record<string, string | null>): void => {
  const updatedQuery = { ...router.query }

  // Update query parameters based on the params object
  Object.keys(params).forEach(key => {
    if (params[key] === null) {
      delete updatedQuery[key]
    } else {
      updatedQuery[key] = params[key]
    }
  })

  router.replace({ pathname: router.pathname, query: updatedQuery }, undefined, { shallow: true })
}
